import { axios } from '@/utils/request'

const api = {
  areaTreeData: '/api/utils/areatree',
  areaListData: '/api/utils/arealist',
  areaHashData: '/api/utils/areahash',
  areaCountData: '/api/utils/areaCount',
  cityOption:'api/utils/areaIndexTree'

}

export default api

export function getCityOption(parameter) {
  return axios({
    url: api.cityOption,
    method: 'get',
    params: parameter
  })
}

export function getAreaTree(parameter) {
  return axios({
    url: api.areaTreeData,
    method: 'get',
    params: parameter
  })
}
export function getAreaList(parameter) {
  return axios({
    url: api.areaListData,
    method: 'get',
    params: parameter
  })
}

export function getAreaHash(parameter) {
  return axios({
    url: api.areaHashData,
    method: 'get',
    params: parameter
  })
}

export function getAreaCount(parameter) {
  return axios({
    url: api.areaCountData,
    method: 'get',
    params: parameter
  })
}
